import { Colors, LineArt } from "../../config/DesignConstants";
import { GameEvents } from "../../core/entity/Entity";
import { createGraphics, GameGraphics } from "../../core/entity/GameSprite";
import { V } from "../../core/Vector";
import { LevelEntity } from "../LevelEntity";
import { SHIELD_RADIUS } from "../turret/Shield";

export class AimLine extends LevelEntity {
  pausable = false;
  sprite: GameGraphics;

  constructor() {
    super();
    this.sprite = createGraphics("cursor");
  }

  onTick(): void {
    if (!this.game) return;

    // Convert turret position (world origin) to screen coordinates
    const turretScreenPos = this.game.camera.toScreen(V(0, 0));

    // Mouse position is already in screen coordinates
    const mouseScreenPos = this.game.io.mousePosition;

    // Calculate direction vector from turret to mouse
    const direction = V(
      mouseScreenPos.x - turretScreenPos.x,
      mouseScreenPos.y - turretScreenPos.y,
    );
    const directionNormalized = direction.normalize();

    // Start line just past the shield radius
    const shieldScreenRadius = SHIELD_RADIUS * this.game.camera.z;
    const startPos = V(
      turretScreenPos.x + directionNormalized.x * shieldScreenRadius,
      turretScreenPos.y + directionNormalized.y * shieldScreenRadius,
    );

    // Extend line to screen edge
    const [screenWidth, screenHeight] = this.game.camera.getViewportSize();
    const maxDistance = Math.max(screenWidth, screenHeight) * 2; // Ensure it reaches edge
    const endPos = V(
      startPos.x + directionNormalized.x * maxDistance,
      startPos.y + directionNormalized.y * maxDistance,
    );

    this.sprite.clear();

    // Create dotted line by drawing multiple small segments
    const dashLength = 8;
    const gapLength = 6;
    const totalDistance = startPos.sub(endPos).magnitude;

    for (
      let distance = 0;
      distance < totalDistance;
      distance += dashLength + gapLength
    ) {
      const segmentStart = V(
        startPos.x + directionNormalized.x * distance,
        startPos.y + directionNormalized.y * distance,
      );
      const segmentEnd = V(
        startPos.x +
          directionNormalized.x *
            Math.min(distance + dashLength, totalDistance),
        startPos.y +
          directionNormalized.y *
            Math.min(distance + dashLength, totalDistance),
      );

      this.sprite
        .moveTo(segmentStart.x, segmentStart.y)
        .lineTo(segmentEnd.x, segmentEnd.y)
        .stroke({
          color: Colors.CYAN,
          width: LineArt.LINE_WIDTH.STANDARD,
          alpha: 0.6,
        });
    }
  }
}
